"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import cx from "classnames";
import SSRIcon from "@ingka/ssr-icon";
const Pill = forwardRef(
  (props, ref) => {
    const {
      prefix = "",
      iconOnly = false,
      label,
      selected = false,
      disabled = false,
      size = "medium",
      thumbnail,
      ssrIcon,
      iconPosition = "leading",
      thumbnailAlt,
      className,
      onClick,
      ...other
    } = props;
    const baseClass = `${prefix}pill`;
    const pillClasses = cx(
      `${baseClass}`,
      size !== "medium" && `${baseClass}--${size}`,
      iconOnly && ssrIcon && !thumbnail && `${baseClass}--icon`,
      !iconOnly && ssrIcon && !thumbnail && `${prefix}${iconPosition}-icon`,
      thumbnail && `${baseClass}--thumbnail`,
      selected && !disabled && `${baseClass}--active`,
      className
    );
    return /* @__PURE__ */ jsxs(
      "button",
      {
        ref,
        className: pillClasses,
        disabled,
        "aria-pressed": selected ? "true" : "false",
        onClick,
        ...other,
        children: [
          thumbnail && /* @__PURE__ */ jsx(
            "img",
            {
              className: `${baseClass}__thumbnail`,
              src: thumbnail,
              alt: thumbnailAlt
            }
          ),
          ssrIcon && !thumbnail && /* @__PURE__ */ jsx(
            SSRIcon,
            {
              prefix,
              paths: ssrIcon,
              className: `${baseClass}__icon`
            }
          ),
          label && /* @__PURE__ */ jsx("span", { className: `${baseClass}__label`, children: label })
        ]
      }
    );
  }
);
Pill.displayName = "Pill";
var Pill_default = Pill;
export {
  Pill_default as default
};
